(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	

	/* Add class to remove margin bottom if element is visible */
	if ( $('.page-separator').parents('.box.box--shadow').length == 1 ) { 

		$('.box.box--shadow:first-child').addClass('no-margin--bottom');
	}

})();